import React from 'react';
import { Outlet } from 'react-router-dom';

const ProjectMngPage = () => {
  return <Outlet />;
};

export default ProjectMngPage;
